module.exports = {"contact":{"email":{"feedback":"feedback@yoop.app","sales":"ventes@yoop.app","press":"info@yoop.app","support":"support@yoop.app"},"zendesk":{"base":"https://yoop.zendesk.com/hc/fr-ca","customPaths":{"virtualEvents":"/sections/360009057052-Événements-virtuels"}},"social":{"instagram":"https://www.instagram.com/yoop/","twitter":"https://twitter.com/yoop","facebook":"https://www.facebook.com/yoopevents"}}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src426716145/src/modules/web/src/js/i18n/french/contact.fr.i18n.json
// module id = 1219
// module chunks = 0